<template>
  <div class="totals-box mb-2" :class="total.price_changed ? 'outline-red' : ''" @click.stop.prevent="$emit('openSidebar')">
    <div class="d-flex p-0 col-2 justify-content-between">
      <div class="totals-info-wrapper col-4 p-0">
        <a href="#">
          <div @click.stop.prevent="goToJob" class="total-ref-id pointer">{{ total.ref_id }}</div>
        </a>
        <div class="total-info">
          {{ total.sales }}
        </div>
      </div>
      <div class="totals-info-wrapper col-4 p-0">
        <div class="total-info">
          {{ total.company_name }}
        </div>
        <div class="total-info" v-if="total.carrier">
          {{ total.carrier.name }}
        </div>
      </div>
      <div class="totals-info-wrapper col-4 p-0">
        <div class="total-info">
          {{ total.date }}
        </div>
        <div class="total-info">
          <i class="fa fa-user totals-icon" />
          {{ total.movers }}
        </div>
        <div class="total-info">
          ${{ total.rate }}
        </div>
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="total-info-numbers">
        {{ total.time }}
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="total-info-numbers">
        {{ total.cash_payment }}
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="total-info-numbers">
        {{ total.total_credit }}
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="total-info-numbers">
        {{ total.total_price }}
        <span v-if="total.price_changed" class="red-text">
          &nbsp;({{ total.price_difference }})
        </span>
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="total-info-numbers">
        {{ total.deposit }}
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="total-info-numbers">
        {{ total.carrier_total }}
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="total-info-numbers">
        {{ total.cluster_total }}
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="total-info-numbers">
        {{ total.balance }}
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="total-info-numbers">
        {{ total.mod_tier_id ? `${total.mod_tier_percentage}%` : `${total.percent}% (${total.fee })` }}
      </div>
    </div>
    <div class="totals-info-wrapper col-1 p-0">
      <div class="d-flex align-items-center justify-content-between">
        <div class="total-info-numbers">
          {{ total.card_tips }}
        </div>
        <span v-if="total.payment_status_id === 3" class="mr-2 total-status-paid">
          paid
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    total: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goToJob() {
      window.open(this.$router.resolve(`/jobs/edit/${this.total.job_id}`).href, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.outline-red {
  border: 1px solid #ff0000;
}

.totals-box {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0 2px 9px -4px rgba(15, 20, 54, 0.17), 0 7px 25px -3px rgba(50, 50, 93, 0.03);
  border-radius: 2px;
  height: 70px;
}
.totals-box > div:first-child > div:first-child {
  padding: 12px 0 0 12px !important;
}
.totals-info-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.total-ref-id {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
}
.total-ref-id:hover {
  color: #2962ff;
}
.total-info {
  font-size: 10px;
  color: #4c5669;
}
.total-info-numbers {
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #4c5669;
}
.totals-icon {
  color: #c0c6cc;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/TotalsBlock.vue